import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import { App } from "./App";
import { globals, theme } from "./theme/tokens";

// The theme class carries the token values; `globals` is the reset. Both are
// static classes produced at build time — nothing computes styles at runtime.
document.documentElement.classList.add(theme, globals);

const root = document.getElementById("root");
if (!root) throw new Error("The #root element is missing from index.html");

createRoot(root).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
